import type { FunctionComponent } from "react";
import Profile from "components/shared/Profile";
import Address from "components/shared/Address";
import { formatDate } from "common/helpers";
import { useSelector } from "react-redux";
import { selectors } from "store";

export interface CompanyInfoProps {
  type?: string;
  name?: string;
  number?: string;
  vat?: string;
  address?: {
    buildingName?: string;
    buildingNumber?: string;
    line1: string;
    line2?: string;
    city: string;
    postcode: string;
  };
}

const CompanyInfo: FunctionComponent<CompanyInfoProps> = function ({
  type,
  name,
  number,
  vat,
  address,
}) {
  const company = useSelector(selectors.company.getEntity);

  const createdAt = formatDate(company?.metadata?.created_at);
  const updatedAt = formatDate(company?.metadata?.updated_at);

  const isLimitedCompany = type === "Limited company";

  return (
    <Profile.Section>
      <Profile.Property label="Company type" value={type} />
      <Profile.Property
        label={isLimitedCompany ? "Company name" : "Trading name"}
        value={name}
      />
      <Profile.Property
        label={isLimitedCompany ? "Company Number" : "NI Number"}
        value={number}
      />
      {isLimitedCompany ? (
        <Profile.Property label="VAT Number" value={vat} />
      ) : (
        <></>
      )}
      <Profile.Property
        label={isLimitedCompany ? "Company Address" : "Trading Address"}
      >
        <Address address={address} />
      </Profile.Property>
      <Profile.Property
        label="Created at"
        value={[createdAt.date, createdAt.time].join(" ")}
      />
      <Profile.Property
        label="Updated at"
        value={[updatedAt.date, updatedAt.time].join(" ")}
      />
    </Profile.Section>
  );
};

export default CompanyInfo;
